import { MessageFooter } from '@zg-rentals/satellite-components';
import { memo } from 'react';

type PhoneLeadProps = {
  isMessageOwner: boolean;
  messageContent: string;
  messageDateMs: string;
};

function PhoneLead({ isMessageOwner, messageContent, messageDateMs }: PhoneLeadProps): JSX.Element {
  return (
    <>
      <audio controls={true}>
        <source src={messageContent} />
      </audio>

      <MessageFooter isMessageOwner={isMessageOwner} messageDateMs={messageDateMs} />
    </>
  );
}

export default memo(PhoneLead);
